import _ from 'lodash';
import * as actions from 'app/actions/onboarding';

/**
 * Common Reducer store for items such as user info and elements present accross pages
 */
export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_SELECT_PAGE: {
      return Object.assign({}, state, {
        selectMachinePage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_INSTRUCTIONS_PAGE: {
      return Object.assign({}, state, {
        instructionsPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_UNBOXING_PAGE: {
      return Object.assign({}, state, {
        unboxingPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_GLOWFORGE_NAME_PAGE: {
      return Object.assign({}, state, {
        glowforgeNamePage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_AIR_FILTER_CHOICE_PAGE: {
      return Object.assign({}, state, {
        airFilterChoicePage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_ONBOARDING_FINISH_PAGE: {
      return Object.assign({}, state, {
        finishPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_SELECTED_MODE: {
      return Object.assign({}, state, {
        mode: action.mode,
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/onboarding.js